import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { viewRewardUser, removeRewardUser } from "../../Redux/Actions/rewardsAction";
import { sendNotification } from "../../Redux/Actions/notificationActions";
import toast from "react-hot-toast";
import MainLayout from "../../Layout/mainLayout";
import "./viewReward.css";

const ViewUserRewards = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const rewardState = useSelector((state) => state.rewards || {});
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");

  const [isRemoving, setIsRemoving] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewRewardUser(id));
  }, [dispatch, id]);

  const data = rewardState.rewardHistoryDetails || {};
  const user = data.user || {};

  const autoSendNotification = async () => {
    if (!user._id) return;

    const payload = {
      title: "Reward Points Redeemed",
      message: `Your reward has been successfully sent to your mail.`,
      type_name: "rewards",
      type_id: data.voucher || "a1b2c3d4e5f678901234abcd",
      type_data: {
        images: data.image ? [data.image] : [],
        cover_photo: data.image,
        title: data.title,
        description: data.description,
        reward_points: data.reward_points,
        category: data.category,
        status: data.status,
        how_to_redeem: data.how_to_redeem,
        terms_and_conditions: data.terms_and_conditions,
      },
      type: "selected",
      notification_for: "user",
      list: [user._id],
    };

    const res = await dispatch(sendNotification(payload));
    if (res?.success) {
      toast.success("Notification sent to user.");
    } else {
      toast.error("Reward done but notification failed.");
    }
  };

  const handleRemove = () => {
    if (!data._id) return;

    const confirmToastId = toast.custom((t) => (
      <div className="vur-toast">
        <p className="vur-toast-message">
          Are you sure you want to Done these reward points?
        </p>
        <div className="vur-toast-actions">
          <button
            onClick={() => {
              setIsRemoving(true);
              dispatch(removeRewardUser(data._id))
                .then((res) => {
                  setIsRemoving(false);
                  toast.dismiss(confirmToastId);
                  if (res?.success !== false) {
                    autoSendNotification();
                  }
                })
                .catch(() => {
                  setIsRemoving(false);
                  toast.dismiss(confirmToastId);
                });
            }}
            className="vur-toast-btn vur-toast-btn--yes"
          >
            Yes
          </button>
          <button
            onClick={() => toast.dismiss(confirmToastId)}
            className="vur-toast-btn vur-toast-btn--no"
          >
            No
          </button>
        </div>
      </div>
    ));
  };

  return (
    <MainLayout>
      <div
        className="vur-wrapper"
        style={{ opacity: isRemoving ? 0.6 : 1, pointerEvents: isRemoving ? "none" : "auto" }}
      >
        <div className="vur-header">
          <div className="vur-header-left">
            <Link to="/rewards" className="vur-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vur-header-divider" />
            <div>
              <div className="vur-breadcrumb">Rewards / List / View</div>
              <h1 className="vur-title">Reward User Points Details</h1>
            </div>
          </div>
        </div>

        <div className="vur-hero-card">
          <div className="vur-hero-left">
            <div>
              <div className="vur-hero-label">Category</div>
              <div className="vur-hero-value">{data.category || "—"}</div>
            </div>
            {data.reward_points !== undefined && (
              <div className="vur-points-badge">
                <span className="vur-points-label">Points</span>
                {data.reward_points}
              </div>
            )}
          </div>
          <div className="vur-hero-meta">
            {data.email && (
              <div className="vur-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                {data.email}
              </div>
            )}
            {data.contact_number && (
              <div className="vur-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                {data.contact_number}
              </div>
            )}
          </div>
        </div>

        <div className="vur-grid-layout">
          <div className="vur-col">
            {data.image && (
              <div className="vur-card">
                <div className="vur-card-header">
                  <span className="vur-card-badge">01</span>
                  <h2 className="vur-card-title">Image</h2>
                </div>
                <div className="vur-image-wrap">
                  <img src={data.image} alt={data.title} className="vur-image" />
                </div>
              </div>
            )}

            <div className="vur-card">
              <div className="vur-card-header">
                <span className="vur-card-badge">{data.image ? "02" : "01"}</span>
                <h2 className="vur-card-title">User Details</h2>
              </div>
              <div className="vur-info-grid">
                <div className="vur-info-item">
                  <span className="vur-info-label">Name</span>
                  <span className="vur-info-value">{user.name || "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Email</span>
                  <span className="vur-info-value">{user.email || "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Contact Number</span>
                  <span className="vur-info-value">
                    {user.country_code || ""} {user.contact_number || "No Data"}
                  </span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Total Credit Balance</span>
                  <span className="vur-points-value">{user.total_credit_balance ?? "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Total Credit Avail</span>
                  <span className="vur-points-value">{user.total_credit_avail ?? "No Data"}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="vur-col">
            <div className="vur-card">
              <div className="vur-card-header">
                <span className="vur-card-badge">{data.image ? "03" : "02"}</span>
                <h2 className="vur-card-title">Reward Details</h2>
              </div>
              <div className="vur-info-grid">
                <div className="vur-info-item">
                  <span className="vur-info-label">Title</span>
                  <span className="vur-info-value">{data.title || "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Category</span>
                  <span className="vur-info-value">{data.category || "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Reward Points</span>
                  <span className="vur-points-value">{data.reward_points ?? "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Status</span>
                  <span className="vur-info-value">{data.status || "No Data"}</span>
                </div>
                <div className="vur-info-item">
                  <span className="vur-info-label">Contact Number</span>
                  <span className="vur-info-value">{data.contact_number || "No Data"}</span>
                </div>
                <div className="vur-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vur-info-label">Email</span>
                  <span className="vur-info-value">{data.email || "No Data"}</span>
                </div>
                <div className="vur-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vur-info-label">Description</span>
                  <span className="vur-info-value">{data.description || "No Data"}</span>
                </div>
                {/* {Array.isArray(data.how_to_redeem) && data.how_to_redeem.length > 0 && (
                  <div className="vur-info-item" style={{ gridColumn: "span 2" }}>
                    <span className="vur-info-label">How to Redeem</span>
                    <ul style={{ margin: "4px 0 0 0", paddingLeft: "16px" }}>
                      {data.how_to_redeem.map((step, i) => (
                        <li key={i} className="vur-info-value">{step}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {Array.isArray(data.terms_and_conditions) && data.terms_and_conditions.length > 0 && (
                  <div className="vur-info-item" style={{ gridColumn: "span 2" }}>
                    <span className="vur-info-label">Terms & Conditions</span>
                    <ul style={{ margin: "4px 0 0 0", paddingLeft: "16px" }}>
                      {data.terms_and_conditions.map((term, i) => (
                        <li key={i} className="vur-info-value">{term}</li>
                      ))}
                    </ul>
                  </div>
                )} */}
              </div>

              {canAdd && (
                <div
                  className="vur-actions"
                  style={{ marginTop: "20px", paddingTop: "16px", borderTop: "1px solid var(--vur-border)" }}
                >
                  <button
                    onClick={handleRemove}
                    disabled={isRemoving}
                    className="vur-done-btn"
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    {isRemoving ? "Processing…" : "Done Reward Points"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewUserRewards;